<template>
  <div class="content-wrapper">
    <ContentHeader title="Топливные талоны" />
    <div class="content-body">
      <BillTable
        title="ДЕТАЛИЗАЦИЯ ПО ТОПЛИВНЫМ ТАЛОНАМ"
        topCaption
        :itemsPerPage="10"
        :fields="fields"
        :items="tickets"
        :busy="isTicketsLoading"
        :failed="isTicketsFailed"
      >
        <template slot="top">
          <div class="card-block">
            <div class="row">
              <div class="col-md-2">
                <select
                  id="ticketType"
                  name="ticket_type"
                  class="form-control"
                  v-model="ticket_type"
                >
                  <option value="active">Активные</option>
                  <option value="used">Погашенные</option>
                  <option value="block">Заблокированные</option>
                </select>
              </div>
              <div class="col-md-10">
                <div class="form-group text-xs-right">
                  <DownloadTableXLSXButton :filename="filename" :fields="fields" :items="tickets" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </BillTable>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import BillTable from "@/components/BillTable";
import DownloadTableXLSXButton from "@/components/DownloadTableXLSXButton.vue";
import { mapGetters } from "vuex";
import { TICKETS_REQUEST } from "@/store/actions/tickets";

export default {
  name: "CardsTransactions",
  components: {
    ContentHeader,
    BillTable,
    DownloadTableXLSXButton,
  },
  data() {
    return {
      ticket_type: this.$route.query.ticket_type || "active",
      fieldsActive: [
        {
          key: "ticket_id",
          label: "№ топливного талона",
        },
        {
          key: "cdate",
          label: "Дата активации",
          formatter: (value) => {
            return new Date(value).toLocaleDateString();
          },
        },
        {
          key: "edate",
          label: "Дата окончания",
          formatter: (value) => {
            return new Date(value).toLocaleDateString();
          },
        },
        {
          key: "left",
          label: "Остаток дней",
          formatter: (value, key, item) => {
            return Math.round(
              (new Date(item.edate) - new Date(item.cdate)) /
                (1000 * 60 * 60 * 24)
            );
          },
        },
        {
          key: "product_name",
          label: "Вид топлива",
        },
        {
          key: "quantity",
          label: "Номинал, литры",
        },
      ],
      fieldsUsed: [
        {
          key: "ticket_id",
          label: "№ топливного талона",
        },
        {
          key: "auth_date",
          label: "Дата заправки",
          formatter: (value) => {
            return new Date(value).toLocaleDateString();
          },
        },
        {
          key: "auth_time",
          label: "Время заправки",
          formatter: (value, index, item) => {
            return new Date(item.auth_date).toLocaleTimeString();
          },
        },
        {
          key: "azs",
          label: "АГЗС",
          formatter: (value, key, item) => {
            return `АГЗС №${value} ${item.region}`;
          },
        },
        {
          key: "product_name",
          label: "Вид топлива",
        },
        {
          key: "quantity",
          label: "Номинал, литры",
        },
        {
          key: "transaction_id",
          label: "Номер транзакции",
        },
      ],
      fieldsBlock: [
        {
          key: "ticket_id",
          label: "№ топливного талона",
        },
        {
          key: "cdate",
          label: "Дата активации",
          formatter: (value) => {
            return new Date(value).toLocaleDateString();
          },
        },
        {
          key: "edate",
          label: "Дата окончания",
          formatter: (value) => {
            return new Date(value).toLocaleDateString();
          },
        },
        {
          key: "product_name",
          label: "Вид топлива",
        },
        {
          key: "quantity",
          label: "Номинал, литры",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getTickets",
      "ticketsOnceLoaded",
      "isTicketsLoading",
      "isTicketsFailed",
    ]),
    fields() {
      switch (this.ticket_type) {
        case "active":
          return this.fieldsActive;
        case "used":
          return this.fieldsUsed;
        case "block":
          return this.fieldsBlock;
        default:
          return this.fieldsActive;
      }
    },
    tickets() {
      switch (this.ticket_type) {
        case "active":
          return this.getTickets.active;
        case "used":
          return this.getTickets.used;
        case "block":
          return this.getTickets.block;
        default:
          return this.getTickets.active;
      }
    },
    filename() {
      switch (this.ticket_type) {
        case "used":
          return "Детализация по погашенным топливным талонам";
        case "block":
          return "Детализация по заблокированным топливным талонам";
        case "active":
        default:
          return "Детализация по активным топливным талонам";
      }
    },
  },
  methods: {},
  created() {
    if (!this.ticketsOnceLoaded) this.$store.dispatch(TICKETS_REQUEST);
  },
};
</script>